import {apiErrorHandler} from '../services/api_error_handler/api_error_handler';

import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONTRACT_DETAILS_EXPERIENCE_API,
});

const OKTA_TOKEN_STORAGE = 'okta-token-storage';
const NONMFA_TOKEN_STORAGE = 'nonMFAToken';

const octaUrlArray = [
  'customerRegistrationDetails',
  'forgotOrgPassword?',
  'setOrgNewPassword?',
  'validateEmail?',
  'sms?',
  'email?',
  'unlockRequests?',
  'unlockRequests?',
  'sms?',
  /^contracts$/,
  /^paymentHistory$/,
  'getNonMfaCustomerOffer',
  'nonMfaResaleAssets',
];

const nonMfaUrlArray = [
  'submitNonMfaCustomerOffer',
  'submittedNonMfaCustomerOffer',
  'submitNonMfaResaleAssetEnquiry',
  'nonMfaPreviousResaleEnquiry',
  'nonMfaUserProfile',
  'updateNonMfaProfile',
];

export const setupAxiosClient = ({dispatch, getState}, axiosInstance) => {
  const onRequestSuccess = (config) => {
    config.headers['trace_id'] = localStorage.getItem('trace-id');
    if (octaUrlArray.some((octaUrl) => config.url.match(octaUrl))) {
      config.headers[
        'Authorization'
      ] = `${process.env.REACT_APP_EXPERIENCE_API_ST}`;
    } else if (
      nonMfaUrlArray.some((nonMfaUrl) => config.url.match(nonMfaUrl))
    ) {
      let nonMfaTokenStorage =
        window.sessionStorage.getItem(NONMFA_TOKEN_STORAGE) &&
        JSON.parse(window.sessionStorage.getItem(NONMFA_TOKEN_STORAGE));
      if (nonMfaTokenStorage.nonMFAToken) {
        config.headers['Authorization'] = `${nonMfaTokenStorage.nonMFAToken}`;
      } else {
        apiErrorHandler('Submit Error', 'SUBMIT_ERROR', true, '/offerslist');
      }
    } else {
      let oktaTokenStoage =
        window.localStorage.getItem(OKTA_TOKEN_STORAGE) &&
        JSON.parse(window.localStorage.getItem(OKTA_TOKEN_STORAGE));
      if (oktaTokenStoage.accessToken) {
        config.headers[
          'Authorization'
        ] = `${oktaTokenStoage.accessToken.accessToken}`;
      } else {
        apiErrorHandler('sign out', 'SIGN_OUT', true, '/signOut');
      }
    }
    return config;
  };

  const onRequestError = (error) => Promise.reject(error.response);

  const onResponseSucess = (response) => response;
  const onResponseError = (error) => Promise.reject(error);

  axiosInstance.interceptors.request.use(onRequestSuccess, onRequestError);
  axiosInstance.interceptors.response.use(onResponseSucess, onResponseError);
};

export default instance;
